import angular from 'angular';
import uiRouter from 'angular-ui-router';
import pageLayoutComponent from './pageLayout.component';

const pageLayoutModule = angular.module('pageLayout', [
  uiRouter,
  'constants',
  'app.services'
])

.component('pageLayout', pageLayoutComponent);

export default pageLayoutModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/pageLayout/pageLayout.js
 **/